import type React from "react";

import { Box } from "@mui/material";
import { useRoutes } from "react-router-dom";

import {
  Goal,
  HealthQuestionnaires,
  HealthQuestionnairesV2,
  MedicalRecord,
  PersonalDetails,
  SignUpQuestions,
} from "./views";

export const InformationRoutes: React.FC = () => {
  const routes = useRoutes([
    {
      path: "journal",
      element: <MedicalRecord />,
    },
    {
      path: "sign-up-questions",
      element: <SignUpQuestions />,
    },
    {
      path: "goals",
      element: <Goal />,
    },
    {
      path: "personal",
      element: <PersonalDetails />,
    },
    {
      path: "health-reports",
      element: <HealthQuestionnaires />,
    },
    {
      path: "health-reports-v2",
      element: <HealthQuestionnairesV2 />,
    },
  ]);

  return (
    <Box bgcolor="white" minHeight="100vh">
      {routes}
    </Box>
  );
};
